import { DictionaryResponseType, DictionaryType } from 'V2/Types/Dictionary';

export const transformDictionaryResponse = (
  response: DictionaryResponseType
): DictionaryType => {
  const coverages = response.coverages.reduce<DictionaryType['coverages']>(
    (acc, item) => {
      acc[item.type] = item;
      return acc;
    },
    {} as DictionaryType['coverages']
  );

  return { coverages };
};
